"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUFFER_CHANGE = 'bufferChange';

function changeBuffer(buffer) {
  return {
    payload: {
      buffer: buffer
    },
    type: exports.BUFFER_CHANGE
  };
}

exports.changeBuffer = changeBuffer;
exports.HINTS_CLOSE = 'hintsClose';

function closeHints() {
  return {
    payload: {},
    type: exports.HINTS_CLOSE
  };
}

exports.closeHints = closeHints;
exports.HINTS_SHOW = 'hintsShow';

function showHints(completions) {
  return {
    payload: {
      completions: completions
    },
    type: exports.HINTS_SHOW
  };
}

exports.showHints = showHints;